import styles from "../styles/variable.module.scss";

export const styledComponents = {
  Input: {
    colorPrimaryHover: styles.colorFormHover,
    borderRadius: 5,
    controlHeight: 40,
    errorFontSize: 12
  },
  Table: {
    colorFillAlter: styles.colorBgLightShadow,
    lineHeight: 2.5,
    fontWeightStrong: 600,
    colorTextHeading: styles.colorTableHeading
  },
  Card: {
    borderRadiusLG: 10,
    colorBorderSecondary: styles.cardBorderColor
  },
  Modal: {
    borderRadiusLG: 10,
    colorBgBase: styles.colorFormHover
  },
  Form: {
    margin: 10,
    marginLG: 15
  },
  Select: {
    colorBorderSecondary: styles.cardBorderColor,
    controlHeight: 40
  },
  Button: {
    controlHeight: 40
  },
  Progress: {
    colorBgContainer: styles.colorPrimary,
    colorInfo: styles.colorPrimary,
    colorFillSecondary: styles.colorBG,
    motionDurationSlow: "2s",
    // eslint-disable-next-line spellcheck/spell-checker
    motionEaseInOutCirc: "cubic-bezier(.38,.75,.83,.67)",
    // eslint-disable-next-line spellcheck/spell-checker
    motionEaseOutQuint: "cubic-bezier(.38,.75,.83,.67)"
  }
};
